/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ReferralTriggerType } from './ReferralTriggerType';
import {
    ReferralTriggerTypeFromJSON,
    ReferralTriggerTypeFromJSONTyped,
    ReferralTriggerTypeToJSON,
    ReferralTriggerTypeToJSONTyped,
} from './ReferralTriggerType';

/**
 * An admin-managed referral reward rule. Defines what the referrer earns (amount in USD) and what the referred user must do to qualify (triggerType + triggerValue or, for legacy FIRST_ORDER, minPaymentRequired). triggerCopy + rewardCopy + qualifierCopy carry the human-readable strings the SPA renders on /account so admin owns the user-facing copy end-to-end.
 * @export
 * @interface ReferralRewardThreshold
 */
export interface ReferralRewardThreshold {
    /**
     * 
     * @type {boolean}
     * @memberof ReferralRewardThreshold
     */
    disabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ReferralRewardThreshold
     */
    hidden: boolean;
    /**
     * 
     * @type {number}
     * @memberof ReferralRewardThreshold
     */
    expiration?: number;
    /**
     * The amount in USD given to the referrer when the trigger fires.
     * @type {number}
     * @memberof ReferralRewardThreshold
     */
    amount: number;
    /**
     * For FIRST_ORDER only — minimum USD the referee must spend on a paid order. Ignored by gaming triggers.
     * @type {number}
     * @memberof ReferralRewardThreshold
     */
    minPaymentRequired: number;
    /**
     * 
     * @type {ReferralTriggerType}
     * @memberof ReferralRewardThreshold
     */
    triggerType: ReferralTriggerType;
    /**
     * Numeric trigger argument. For LEVEL_REACHED this is the level number (e.g. 5). For FIRST_QUEST_COMPLETED / FIRST_FUEL_PURCHASE / FIRST_ORDER this is unused (validators ignore it).
     * @type {number}
     * @memberof ReferralRewardThreshold
     */
    triggerValue?: number;
    /**
     * Admin-editable human label for the trigger, surfaced on /account ("Level 5", "their first quest", "their first Fuel purchase", etc.). When empty, the SPA derives a default from triggerType + triggerValue.
     * @type {string}
     * @memberof ReferralRewardThreshold
     */
    triggerCopy?: string;
    /**
     * Admin-editable human label for the referrer reward, surfaced on /account ("$20 in FUEL", "500 FUEL", etc.). When empty, the SPA derives a default from amount + the configured Fuel price.
     * @type {string}
     * @memberof ReferralRewardThreshold
     */
    rewardCopy?: string;
    /**
     * Admin-editable disclaimer / fine-print line shown beneath the share-link block on /account. When empty, the SPA omits the fine-print line.
     * @type {string}
     * @memberof ReferralRewardThreshold
     */
    qualifierCopy?: string;
    /**
     * Optional RewardConfig id granted to the referrer when the trigger fires. When set, the payout is dispatched through the generic reward distributor (any RewardType — FUEL, FUELUP_MOVES, XP, etc.), making the reward fully config-driven. When empty, the legacy USD→FUEL `amount` payout is used.
     * @type {string}
     * @memberof ReferralRewardThreshold
     */
    rewardConfigId?: string;
    /**
     * 
     * @type {string}
     * @memberof ReferralRewardThreshold
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof ReferralRewardThreshold
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof ReferralRewardThreshold
     */
    updatedAt: number;
}



/**
 * Check if a given object implements the ReferralRewardThreshold interface.
 */
export function instanceOfReferralRewardThreshold(value: object): value is ReferralRewardThreshold {
    if (!('disabled' in value) || value['disabled'] === undefined) return false;
    if (!('hidden' in value) || value['hidden'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('minPaymentRequired' in value) || value['minPaymentRequired'] === undefined) return false;
    if (!('triggerType' in value) || value['triggerType'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function ReferralRewardThresholdFromJSON(json: any): ReferralRewardThreshold {
    return ReferralRewardThresholdFromJSONTyped(json, false);
}

export function ReferralRewardThresholdFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReferralRewardThreshold {
    if (json == null) {
        return json;
    }
    return {
        
        'disabled': json['disabled'],
        'hidden': json['hidden'],
        'expiration': json['expiration'] == null ? undefined : json['expiration'],
        'amount': json['amount'],
        'minPaymentRequired': json['minPaymentRequired'],
        'triggerType': ReferralTriggerTypeFromJSON(json['triggerType']),
        'triggerValue': json['triggerValue'] == null ? undefined : json['triggerValue'],
        'triggerCopy': json['triggerCopy'] == null ? undefined : json['triggerCopy'],
        'rewardCopy': json['rewardCopy'] == null ? undefined : json['rewardCopy'],
        'qualifierCopy': json['qualifierCopy'] == null ? undefined : json['qualifierCopy'],
        'rewardConfigId': json['rewardConfigId'] == null ? undefined : json['rewardConfigId'],
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
    };
}

export function ReferralRewardThresholdToJSON(json: any): ReferralRewardThreshold {
    return ReferralRewardThresholdToJSONTyped(json, false);
}

export function ReferralRewardThresholdToJSONTyped(value?: ReferralRewardThreshold | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'disabled': value['disabled'],
        'hidden': value['hidden'],
        'expiration': value['expiration'],
        'amount': value['amount'],
        'minPaymentRequired': value['minPaymentRequired'],
        'triggerType': ReferralTriggerTypeToJSON(value['triggerType']),
        'triggerValue': value['triggerValue'],
        'triggerCopy': value['triggerCopy'],
        'rewardCopy': value['rewardCopy'],
        'qualifierCopy': value['qualifierCopy'],
        'rewardConfigId': value['rewardConfigId'],
        'id': value['id'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
    };
}

